/** Home Hub helpers (pure): Team tools list and My work formatting. KB home-hub.md. */

export interface TeamTool {
  name: string;
  description: string;
  url: string;
}

/**
 * The tools DWA works in (Jon, 2026-11-03), shown on Home as "Team tools".
 * Company-wide, not per person; the per-person list is Quick links.
 */
const TEAM_TOOLS: TeamTool[] = [
  { name: 'HubSpot', description: 'CRM: deals, contacts, companies', url: 'https://app.hubspot.com/' },
  { name: 'Teamwork', description: 'Projects, tasks and time', url: 'https://digitalwolfagency.teamwork.com/' },
  { name: 'Ramp', description: 'Cards, spend and reimbursements', url: 'https://app.ramp.com/' },
  { name: 'BambooHR', description: 'People, time off and HR', url: 'https://digitalwolf.bamboohr.com/' },
  {
    name: 'Google Drive',
    description: 'DWA HQ shared drive',
    url: 'https://drive.google.com/drive/folders/0ACiZiMusQt-iUk9PVA',
  },
];

/** Alphabetical, as Jon asked. */
export const teamTools = (): TeamTool[] => [...TEAM_TOOLS].sort((a, b) => a.name.localeCompare(b.name));

export function formatHours(h: number): string {
  const rounded = Math.round(h * 10) / 10;
  return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1)} h`;
}

export function formatPercent(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}

/** "Over capacity" / "Light week" / "On track" for the planned-hours bar. */
export function loadLabel(ratio: number): { label: string; tone: 'over' | 'light' | 'ok' } {
  if (ratio > 1) return { label: 'Over capacity', tone: 'over' };
  if (ratio < 0.5) return { label: 'Light week', tone: 'light' };
  return { label: 'On track', tone: 'ok' };
}

/** "Nov 3 – 9" or "Oct 27 – Nov 2". */
export function weekLabel(startIso: string, endIso: string): string {
  const s = new Date(`${startIso}T12:00:00`);
  const e = new Date(`${endIso}T12:00:00`);
  const sm = s.toLocaleDateString('en-US', { month: 'short' });
  const em = e.toLocaleDateString('en-US', { month: 'short' });
  return sm === em ? `${sm} ${s.getDate()} – ${e.getDate()}` : `${sm} ${s.getDate()} – ${em} ${e.getDate()}`;
}

export function shortDate(iso: string | null): string {
  if (!iso) return 'No date';
  const d = new Date(`${iso.slice(0, 10)}T12:00:00`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function formatMoney(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}
